import type { DotColor } from "@/components/shared/DotChip";
import type { Localized } from "@/lib/landing/locale";

export type LandingStatus = "matched" | "invoice" | "notNeeded" | "missing" | "unmatched";

/**
 * The app's transaction statuses, worded exactly as the dashboard shows them;
 * `bar` is the StatusStrip segment colour.
 */
export const STATUSES: Record<
  LandingStatus,
  { color: DotColor | undefined; bar: string; label: Localized; meaning: Localized }
> = {
  matched: {
    color: "green",
    bar: "hsl(var(--dot-green))",
    label: { cs: "Spárováno", en: "Matched" },
    meaning: {
      cs: "Platba má doklad.",
      en: "The payment has its document.",
    },
  },
  invoice: {
    color: "blue",
    bar: "hsl(var(--dot-blue))",
    label: { cs: "Faktura", en: "Invoice" },
    meaning: {
      cs: "Příchozí platba k vydané faktuře.",
      en: "An incoming payment for an invoice you issued.",
    },
  },
  notNeeded: {
    color: "amber",
    bar: "hsl(var(--dot-amber))",
    label: { cs: "Nepotřebné", en: "Not needed" },
    meaning: {
      cs: "Doklad není potřeba, třeba bankovní poplatek.",
      en: "No document needed, like a bank fee.",
    },
  },
  missing: {
    color: "red",
    bar: "hsl(var(--dot-red))",
    label: { cs: "Chybí", en: "Missing" },
    meaning: {
      cs: "Doklad chybí a je potřeba ho dohledat.",
      en: "The document is missing and needs to be found.",
    },
  },
  unmatched: {
    color: undefined,
    bar: "hsl(var(--muted-foreground) / 0.35)",
    label: { cs: "Nespárováno", en: "Unmatched" },
    meaning: {
      cs: "Zatím bez dokladu, Zettl ho ještě hledá.",
      en: "No document yet; Zettl is still looking.",
    },
  },
};

/** Row tints of the transactions table, by status. */
export const ROW_TINT: Record<LandingStatus, string> = {
  matched: "bg-[hsl(var(--row-green))]",
  invoice: "bg-[hsl(var(--row-blue))]",
  notNeeded: "bg-[hsl(var(--row-amber))]",
  missing: "bg-[hsl(var(--row-red))]",
  unmatched: "",
};
